import { useConfig } from "@agportal/config";
import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { createSecurityGuard as createSecurityGuardBase } from "@dmvs/composables/security";
import { isEmpty } from "lodash-es";

const config = useConfig();
const logger = useLogger("security");
const configClient = createRestClient({ baseURL: config.endpoints.clientConfig }, { secured: false });

async function loadUserDetails(context) {
    return {
        uozi: await isAziUser(context),
        isPsiAllowed: await isPsiAllowed(),
    };
}

async function isAziUser(context) {
    try {
        const azi = !isEmpty(context.details?.registrUozi);
        logger.debug("Ověřování AZI skončilo s výsledkem {0}.", azi);

        return azi;
    } catch (error) {
        logger.error("Došlo k chybě při ověřování AZI.", error);
    }

    return false;
}

async function isPsiAllowed() {
    try {
        const { data } = await configClient.get("");

        const allowed = data?.psp?.povoleno;
        logger.debug("Ověřování PSP skončilo s výsledkem {0}.", allowed);

        return allowed;
    } catch (error) {
        logger.error("Došlo k chybě při ověřování PSP.", error);
    }

    return false;
}

export function createSecurityGuard() {
    return createSecurityGuardBase({ loadUserDetails });
}
